
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({ name: 'svg-icon' })
export default class indexView extends Vue {
  @Prop({
    type: Number,
    default: '',
  })
  active!: number
  mechanismChange(type: string) {
    this.$router.push({ path: type })
  }
}
